export default {"src":"/_next/static/media/pcsql.195c0166.svg","height":10,"width":37,"blurWidth":0,"blurHeight":0};